module.exports = __webpack_public_path__ + "img/vote-4@2x.cdc4b0ba.png";